import { createContext, Dispatch, SetStateAction } from 'react'
import { BaseAsset } from 'types/Response'

const STAGES = ['idle', 'preview', 'processing', 'finish'] as const
export type Stage = typeof STAGES[number]

export interface MainLayoutContextInterface {
  stage: Stage
  setStage: Dispatch<SetStateAction<Stage>>
  processedAssets: BaseAsset[]
  setProcessedAssets: Dispatch<SetStateAction<BaseAsset[]>>
  currentAssetIndex: number
  setCurrentAssetIndex: Dispatch<SetStateAction<number>>
  openLogInModal: () => void
  openSignUpModal: () => void
}

const MainLayoutContext = createContext<MainLayoutContextInterface>(
  {} as MainLayoutContextInterface,
)

export default MainLayoutContext
